import { render, staticRenderFns } from "./SwitchCarrier.vue?vue&type=template&id=5165a856&"
import script from "./SwitchCarrier.vue?vue&type=script&lang=js&"
export * from "./SwitchCarrier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports